// extracted by mini-css-extract-plugin
export var spotlight = "projectSpotlight-module--spotlight--bj2yd";
export var main = "projectSpotlight-module--main--7OvuL";
export var horizontalScroll = "projectSpotlight-module--horizontalScroll--iIVqO";
export var label = "projectSpotlight-module--label--LMst6";
export var title = "projectSpotlight-module--title--33+nc";
export var subtitle = "projectSpotlight-module--subtitle--4HJy5";
export var slideUp = "projectSpotlight-module--slideUp--NsiJ8";
export var slideUpLarge = "projectSpotlight-module--slideUpLarge--67jFC";